import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import React from 'react';
import {SupportTicketModel} from '../../../../model/support/support-ticket.model';
import {
  SupportTicketUtils,
} from '../utils/support-ticket.utils';

type Props = {
  ticket: SupportTicketModel
  translate: (key: string) => string
  translateLocal: (key: string) => string
}

export const SupportTicketDrawerTicketDescription = ({ticket, translateLocal, translate}: Props) => {
  const buildTitleInput = () =>  <TextField
    label={translateLocal('column.title')}
    value={ticket.title}
    disabled={true}
    required
    fullWidth
  />

  const buildModuleInput = () =>  <TextField
    label={translateLocal('column.module')}
    value={translate(`support.ticket.module.${ticket.module}`)}
    disabled={true}
    required
    fullWidth
  />

  const buildTypeInput = () =>  <TextField
    label={translateLocal('column.type')}
    value={translate(`support.ticket.type.${ticket.type}`)}
    disabled={true}
    required
    fullWidth
  />

  const buildErrorTypeInput = () =>  <TextField
    label={translateLocal('column.error_type')}
    value={ticket.errorType ? translate(`support.ticket.error_type.${ticket.errorType}`) : null}
    disabled={true}
    required
    fullWidth
  />

  const buildPriority = () =>  <TextField
    label={translateLocal('column.priority')}
    value={SupportTicketUtils.ticketPriorityOptions.find(it => it.value === ticket.priority)?.label ?? ''}
    disabled={true}
    required
    fullWidth
  />

  const buildDeadline = () =>  <TextField
    label={translateLocal('column.deadline')}
    value={ticket.customerDeadline}
    disabled={true}
    required
    fullWidth
  />

  const buildBudgetType = () =>  <TextField
    label={translateLocal('column.budgetType')}
    value={SupportTicketUtils.ticketBudgetTypeOptions.find(it => it.value === ticket.customerBudgetType)?.label ?? ''}
    disabled={true}
    required
    fullWidth
  />

  const buildBudget = () =>  <TextField
    label={translateLocal('column.budget')}
    value={ticket.customerBudget}
    disabled={true}
    required
    fullWidth
  />


  const buildDescriptionInput = () => <TextField
    label={translateLocal('column.description')}
    value={ticket.description}
    disabled={true}
    required
    multiline
    minRows={5}
    maxRows={5}
    fullWidth
    sx={{
      '& .MuiInputBase-root': {
        overflow: 'auto',
      },
    }}
  />

  return <Stack spacing={3}>
    {buildTitleInput()}
    {buildModuleInput()}
    <Stack direction="row" spacing={2}>
      <Stack sx={{ flex: 1 }}>{buildTypeInput()}</Stack>
      <Stack sx={{ flex: 1 }}>{buildErrorTypeInput()}</Stack>
    </Stack>
    <Stack direction="row" spacing={2}>
      <Stack sx={{ flex: 1 }}>{buildPriority()}</Stack>
      <Stack sx={{ flex: 1 }}>{buildDeadline()}</Stack>
    </Stack>
    <Stack direction="row" spacing={2}>
      <Stack sx={{ flex: 1 }}>{buildBudgetType()}</Stack>
      <Stack sx={{ flex: 1 }}>{buildBudget()}</Stack>
    </Stack>
    {buildDescriptionInput()}
  </Stack>
}